﻿export interface ValgState {
    visVilkar: boolean;
}

export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export type ValgStateActionTypes = ToggleVilkarAction;
